module.exports = __webpack_public_path__ + "images/thumb-21240d29481fc297565d0dda94326f4b.jpg";